import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M2 2l12.5 12.5L2 27",
  stroke: "#99C6E7",
  strokeWidth: 3
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 17,
    height: 29,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/right-caret-blue.27b64910.svg";
export { SvgComponent as ReactComponent };